import React from "react";
import { TypeAnimation } from "react-type-animation";

import CText from "../Components/CText";

function IntroContainer() {
  return (
    <div>
      {/* <CText className="titleText" text="Hey, Good to see you here!" fontSize="4rem" /> */}
      <TypeAnimation
        sequence={["Hey, Good to see you here!"]}
        wrapper="p"
        speed={50}
        className="titleText"
        style={{ fontSize: "4em" }}
        repeat={0}
      />
      <TypeAnimation
        sequence={[
          "This is a Creative Mind",
          200,
          "This is a Creative Mind, Frontend Developer ",
          1000,
          "This is a Creative Mind, Frontend Developer & an Eternal Learner",
          1000,
        ]}
        wrapper="p"
        speed={30}
        style={{ fontSize: "2em" }}
        repeat={0}
      />
      {/* <CText
        text="This is a Creative Mind, Frontend Developer & an Eternal Learner"
        fontSize="2rem"
      /> */}
      <CText text="I design and code beautifully simple things." fontSize="1.3rem" />
    </div>
  );
}

export default IntroContainer;
